import ErrorBoundary from '01_core/components/system/ErrorBoundary';
import { EN } from '01_core/locales/en';
import { JA } from '01_core/locales/ja';
import { TYPES_LOCALE, coreLocaleActions } from '01_core/reducers/coreLocaleActions';
import coreReducers from '01_core/reducers/coreReducers';
import masterdataReducers from '12_masterdata/common/masterdataReducers';
import usercustomReducers from '13_usercustom/common/usercustomReducers';
import pandeReducers from '22_pande/common/pandeReducers';
import grouphisaiReducers from '23_grouphisai/common/grouphisaiReducers';
import noticeReducers from '24_notice/common/noticeReducers';
import bcmReducers from '31_bcm/common/bcmReducers';
import kansaReducers from '32_kansa/common/kansaReducers';
import React from 'react';
import { connect } from 'react-redux';
import { combineReducers } from 'redux';

import CssBaseline from '@mui/material/CssBaseline';

import commonReducers from '../common/commonReducers';
import Header from '../menubar/Header';
import MenuBar from '../menubar/MenuBar';
import LoginInfoLoader from './LoginInfoLoader';
import NewWindow from './NewWindow';

const reducers = combineReducers(
  Object.assign(
    {},
    coreReducers,
    commonReducers,
    masterdataReducers,
    usercustomReducers,
    pandeReducers,
    grouphisaiReducers,
    noticeReducers,
    bcmReducers,
    kansaReducers,
  ),
);

const BASE_WINDOW_SIZE = 834;
class BaseContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      headerText: true,
      mobile: false,
    };
  }

  componentDidMount() {
    this.props.replaceReducer?.(reducers);
    this.props.setLabel({ en: EN, ja: JA });
    if (!this.props.mode) {
      this.eventHandler = this.menuChange.bind(this);
      window.addEventListener('resize', this.eventHandler);
      if (window.outerWidth < BASE_WINDOW_SIZE) {
        this.setState({
          open: false,
          headerText: false,
          mobile: true,
        }, () => {
          window.dispatchEvent(new Event('resize'));
        });
      }
    }
  }

  t = 0;
  menuChange = () => {
    if (this.t > 0) {
      clearTimeout(this.t);
    }
    this.t = setTimeout(() => {
      const isMobile = window.outerWidth < BASE_WINDOW_SIZE;
      // モバイル判定が切り替わったときのみ状態を更新する。
      if (isMobile === this.state.mobile) {
        return;
      }
      if (isMobile) {
        this.setState({
          open: false,
          headerText: false,
          mobile: true,
        }, () => {
          window.dispatchEvent(new Event('resize'));
        });
      } else {
        this.setState({ headerText: true, mobile: false }, () => {
          window.dispatchEvent(new Event('resize'));
        });
      }
    }, 100);
  };

  render() {
    return (
      <div className='App' style={{ width: '100%', minWidth: 0, padding: this.props.mode === '1' ? '8px 8px 0' : null}}>
        {/* spanはインライン要素のため幅が縮む恐れがある。ブロック化＋100%幅を付与 */}
        <span style={{ display: 'block', width: '100%', minWidth: 0 }}>
          <ErrorBoundary>
            <LoginInfoLoader>
              {this.props.mode === '1' ? (
                <React.Fragment>
                  <CssBaseline />
                  <NewWindow />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Header
                    handleMenuChange={() => {
                      this.setState(
                        (prev) => ({ open: !prev.open }),
                        () => setTimeout(() => window.dispatchEvent(new Event('resize')), 0),
                      );
                    }}
                    closeMenuBar={() => {
                      if (this.state.mobile) {
                        this.setState({ open: false }, () => {
                          setTimeout(() => window.dispatchEvent(new Event('resize')), 0);
                        });
                      }
                    }}
                    headerText={this.state.headerText}
                  />
                  <MenuBar
                    open={this.state.open}
                    mobile={this.state.mobile}
                    closeMenuBar={() => {
                      if (this.state.mobile) {
                        this.setState({ open: false }, () => {
                          setTimeout(() => window.dispatchEvent(new Event('resize')), 0);
                        });
                      }
                    }}
                  />
                </React.Fragment>
              )}
            </LoginInfoLoader>
          </ErrorBoundary>
        </span>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setLabel: (label) => dispatch(coreLocaleActions[TYPES_LOCALE.SET_LABEL](label)),
  };
};

export default connect(null, mapDispatchToProps)(BaseContainer);